export default __webpack_public_path__ + "static/media/mn.d0ab2edd.jpg";